export function SiteNotAvailable() {
  return (
    <div className="dark:text-gray-0 my-5 flex justify-center text-xl">
      <div> This page is not available yet. Come back later</div>
    </div>
  );
}
